import { Field, Model } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { Approval } from '../core/types';

class SchoolType extends Model {
  @Field()
  public entry!: string;
}

class Region extends Model {
  @Field()
  public entry!: string;
}

class Part extends Model {
  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public name!: string;

  @Field()
  public start!: number;

  @Field()
  public end!: number;
}

export class BookJsonModel extends JsonApiModel {
  public static override readonly type = 'books';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public title!: string;

  @Field({ toOne: SchoolType })
  schoolTypes!: SchoolType[];

  @Field({ toOne: Region })
  regions!: Region[];

  @Field()
  public level!: string;

  @Field()
  public subjectId!: string;

  @Field()
  public publisher!: string;

  @Field()
  public externalId!: string;

  @Field()
  public isbn13!: string;

  @Field({ toOne: Part })
  parts!: Part[];

  @Field()
  public coverAvailable!: boolean;

  @Field()
  public active!: boolean;

  @Field()
  approval!: Approval;

  @Field()
  version!: number;

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  changedBy!: string;
}

export interface ExternalBook {
  id: string
  page: string
  title: string
  isbn: string
  subtitle?: string
  title_region?: string

}
